import { useEffect, useState } from "react";
import { generatePersistedDeviceUUID } from "utils/deviceID";
import { isAppRunningInDev } from "utils/utils";

const useGenerateDeviceID = () => {
  const [hasUUID, setHasUUID] = useState(false);

  useEffect(() => {
    const uuidGenerated = generatePersistedDeviceUUID();

    if (isAppRunningInDev()) {
      console.log("device_uuid:", uuidGenerated);
    }

    setHasUUID(true);
  }, []);

  return {
    hasUUID,
  };
};

export default useGenerateDeviceID;
